import React from 'react';
import role from '../../util/role';
import {
  USER_LIST_PAGE_LOADED,
  MERCHANT_LIST_PAGE_LOADED,
  ACCOUNT_GO,
  COIN_LIST_PAGE_LOADED,
  CONTRACT_LIST_PAGE_LOADED,
  MASTER_ACCOUNT_LIST_PAGE_LOADED,
  TASK_WITHDRAW_LOADED,
  TASK_DEPOSIT_LOADED,
  TASK_VERIFICATION_LOADED,
  TASK_KYC_LOADED,
  TASK_GEMINIORDERS_LOADED,
  TRANSACTION_LIST_PAGE_LOADED,
  TRADE_LIST_PAGE_LOADED,
  LOG_LIST_PAGE_LOADED,
  SIGNATURE_PAGE_LOADED,
  ETH_COMMIT_USER_LIST_PAGE_LOADED,
  BTC_COMMIT_USER_LIST_PAGE_LOADED,
  CHAT_CHANNEL_LIST_PAGE_LOADED,
  DEPOSIT_BANK_REFERENCE_CODE_SUBMIT,
  USER_TASK_LIST_LOADED,
  RATES_PAGE_LOADED,
  TOKEN_LIST_PAGE_LOADED
} from '../../constants/actionTypes'
import { Link } from 'react-router-dom';
import { REACT_APP_ENABLE_MERCHANT_FUNCTIONS, REACT_APP_ENABLE_GEMINI_FUNCTIONS, REACT_APP_ENABLE_RATES_FUNCTIONS } from '../../constants/config'

const AuthView = props => {
  if (!props.currentUser) {
    return (
      <div id="menu">
        <ul>
          <li><Link to="/login">Log in</Link></li>
        </ul>
      </div>
    );
  }

  const userRole = props.currentUser.role;

  return (
    <div id="menu">
      <ul>
        <li><Link to="/">Home</Link></li>
        {role.can(userRole, USER_LIST_PAGE_LOADED) ? <li><Link to="/users">Users</Link></li> : null}
        {role.can(userRole, ACCOUNT_GO) ? <li><Link to="/accounts">Accounts</Link></li> : null}
        {role.can(userRole, TASK_KYC_LOADED) ? <li><Link to="/tasks/kyc">ID Verifications</Link></li> : null}
        {/* {role.can(userRole, TRANSACTION_LIST_PAGE_LOADED) ? <li><Link to="/transactions">Transactions</Link></li> : null} */}
        {role.can(userRole, COIN_LIST_PAGE_LOADED) ? <li><Link to="/coins">Transactions</Link></li> : null}
        {role.can(userRole, MASTER_ACCOUNT_LIST_PAGE_LOADED) ? <li><Link to="/masteraccounts">Master Accounts</Link></li> : null}
        {role.can(userRole, LOG_LIST_PAGE_LOADED) ? <li><Link to="/logs">Logs</Link></li> : null}
      </ul>
    </div>
  )
}

class Navigation extends React.Component {
  render() {
    return (
      <AuthView currentUser={this.props.currentUser} />
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/widgets/Navigation.js